import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createCoupon',
    serviceName: 'unitadmin',
    query: gql`
      mutation createCoupon(
        $type: String
        $title: String!
        $amount: Int!
        $shop_id: String!
        $end_date: String
        $start_date: String
        $description: String
        $is_active: Int
      ) {
        createCoupon(
          type: $type
          title: $title
          amount: $amount
          shop_id: $shop_id
          end_date: $end_date
          start_date: $start_date
          description: $description
          is_active: $is_active
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
